import store from "@/store";

export const useApiErrorDialog = () => {
  /** ダイアログのクローズ処理 */
  const closeDialog = () => store.dispatch("common/updatedApiError", null);

  return {
    closeDialog
  };
};
